export default "dist/images/components-columns-width-control-3-2-grid.6b11733.png";